"use client";

import { useCallback, useState } from "react";
import { OnboardingLayout } from "./OnboardingLayout";
import { Screen1Question } from "./screens/Screen1Question";
import { Screen2Question } from "./screens/Screen2Question";
import { Screen3Question } from "./screens/Screen3Question";
import { Screen4Final } from "./screens/Screen4Final";

const TOTAL_SCREENS = 4;

export type OnboardingFlowProps = {
  onComplete?: () => void;
};

export function OnboardingFlow({ onComplete }: OnboardingFlowProps) {
  const [currentScreen, setCurrentScreen] = useState(0);

  const handleFlowComplete = useCallback(() => {
    if (onComplete) {
      onComplete();
    } else {
      setCurrentScreen(0);
    }
  }, [onComplete]);

  const showSkip = currentScreen < TOTAL_SCREENS - 1;

  return (
    <OnboardingLayout
      currentStep={currentScreen}
      totalSteps={TOTAL_SCREENS}
      onSkip={showSkip ? () => setCurrentScreen(TOTAL_SCREENS - 1) : undefined}
    >
      <div key={currentScreen} className="flex flex-1 flex-col">
        {currentScreen === 0 && (
          <Screen1Question onNext={() => setCurrentScreen(1)} />
        )}
        {currentScreen === 1 && (
          <Screen2Question onNext={() => setCurrentScreen(2)} />
        )}
        {currentScreen === 2 && (
          <Screen3Question onNext={() => setCurrentScreen(3)} />
        )}
        {currentScreen === 3 && (
          <Screen4Final onComplete={handleFlowComplete} />
        )}
      </div>
    </OnboardingLayout>
  );
}
